<template>
  <PageWrapper
    :isLoading="isLoading"
    :hasFilters="true"
    @submitFilters="setPageNumberAndSendRequest"
  >
    <template #title>
      تاریخچه جلسات زبان آموز: {{ userFullName ? userFullName : "" }}
    </template>
    <template #titleBtn v-if="!isForAdmin">
      <BButton
        class="titleBtnWidth"
        variant="success"
        @click="renderCreateScheduleHistoryModal"
      >
        افزودن نظر
      </BButton>
    </template>
    <template #filters>
      <SearchInput
        inputId="masterFullName"
        inputLabel="نام استاد"
        inputPlaceholder="امیرحسین..."
        :inputValue="scheduleListFilters.masterFullname"
        v-model="scheduleListFilters.masterFullname"
        @enter="getScheduleList"
      ></SearchInput>
      <SearchInput
        inputId="historyDesc"
        inputLabel="جستجوی توضیحات درس"
        inputPlaceholder="آیلتس..."
        :inputValue="scheduleListFilters.description"
        v-model="scheduleListFilters.description"
        @enter="getScheduleList"
      ></SearchInput>
      <CustomDatePicker
        class="w-24 filters-width"
        inputId="createDateFilterHistory"
        @getSelectedDate="setCreateDateFilter"
        inputLabel="تاریخ جلسه"
        inputPlaceholder="تاریخ جلسه"
      ></CustomDatePicker>
      <IndependentLessonPicker
        :closeOnSelect="true"
        @getLesson="setLesson"
        class="w-24 filters-width"
      ></IndependentLessonPicker>
      <BFormGroup
        label-for="isPassed"
        label="وضعیت جلسات"
        class="w-24 filters-width"
      >
        <BFormSelect
          id="isPassed"
          v-model="scheduleListFilters.isPass"
          :options="passedTypes"
        ></BFormSelect>
      </BFormGroup>
    </template>
    <CustomTable
      :pageNumber="scheduleListFilters.pageNumber"
      :count="scheduleListFilters.count"
      :totalCount="totalCount"
      :tableColumns="myTableColumns"
      :tableItems="scheduleList"
      @changePage="changePage"
    >
      <!-- DSD-669 -->

      <!-- <template #studentFeedBackQuestions="data">
        <div
          class="d-flex flex-column"
          style="max-width: 15rem !important; width: 15rem"
        >
          <b-link
            v-for="question in data.item.studentFeedBackQuestions"
            class="w-100"
            :to="`/questions/${question.questionId}`"
            :key="question.questionId"
            target="_blank"
            style="margin: 0.5rem 0"
          >
            {{ question.questionText }}
          </b-link>
        </div>
      </template> -->
      <template #lastSchaduleDate="data">
        {{ customConvertWeekDay(data.item.lastSchaduleDate) }}
        -
        {{ customFullDateConvert(data.item.lastSchaduleDate) }}
        -
        {{ customConvertHourAndMinute(data.item.lastSchaduleDate) }}
      </template>
      <template #description="data">
        <div class="custom-comment-col" v-html="data.item.description"></div>
      </template>
      <template #isPass="data">
        <div class="w-auto d-flex align-items-center justify-content-center">
          <FeatherIcon
            :icon="data.item.isPass ? 'CheckIcon' : 'XIcon'"
            :class="data.item.isPass ? 'text-success' : 'text-danger'"
            size="20"
          />
        </div>
      </template>

      <!-- DSD-669 -->

      <!-- <template #masterVoice="data">
        <template v-if="data.item.masterVoice">
          <audio
            preload="metadata"
            controls
            :src="`${baseUrl}/${data.item.masterVoice}`"
          ></audio>
        </template>
        <template v-else>-</template>
      </template> -->
      <template #actions="data">
        <BButton
          @click="renderScheduleHistoryUpdateModal(data.item)"
          variant="transparent"
          size="sm"
          v-if="
            scheduleList &&
            scheduleList.length > 0 &&
            canEditComment(data.item.masterUserId)
          "
        >
          <FeatherIcon icon="EditIcon" size="20" class="text-primary" />
        </BButton>
      </template>
    </CustomTable>

    <CreateScheduleHistoryModal
      v-if="!isForAdmin"
      @reFetch="closeScheduleHistoryCreateModal"
      :priceCategoryId="priceCategoryId"
      :studentUserId="userIdFilter"
    ></CreateScheduleHistoryModal>
    <UpdateScheduleHistoryModal
      v-if="!isForAdmin"
      @reFetch="closeScheduleHistoryUpdateModal"
      :defaultScheduleDetails="tempSchedule"
    ></UpdateScheduleHistoryModal>
  </PageWrapper>
</template>

<script>
export default {
  props: {
    userIdFilter: {
      type: [String, Number],
      required: true,
    },
    userFullName: {
      type: [String],
      required: false,
    },
    priceCategoryId: {
      type: [String, Number],
      required: false,
    },
    isForAdmin: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    userIdFilter: {
      immediate: true,
      handler(val) {
        if (val) {
          this.scheduleListFilters.studentUserId = val;
        }
      },
    },
  },
  mounted() {
    if (this.computedPageRouteQuery) {
      this.scheduleListFilters.pageNumber = this.computedPageRouteQuery;
    } else {
      this.scheduleListFilters.pageNumber = 1;
    }
    this.getScheduleList();
  },
  data() {
    return {
      isLoading: false,
      scheduleListFilters: {
        pageNumber: 1,
        count: 10,
        studentUserId: null,
        studentFullname: null,
        studentMobile: null,
        masterFullname: null,
        masterUserId: null,
        createDate: null,
        lessonId: null,
        lessonTitle: null,
        description: null,
        isPass: null,
      },
      scheduleList: null,
      totalCount: null,
      passedTypes: [
        {
          value: null,
          text: "همه",
        },
        {
          value: true,
          text: "قبول شده ها",
        },
        {
          value: false,
          text: "رد شده ها",
        },
      ],
      myTableColumns: [
        {
          key: "lastSchaduleDate",
          label: "آخرین کلاس",
        },
        {
          key: "masterFullname",
          label: "آخرین استاد",
        },
        {
          key: "priceCateogryTitle",
          label: "گروه‌بندی",
        },
        {
          key: "description",
          label: "نظر استاد",
        },
        {
          key: "lessonTitle",
          label: "آخرین درس",
          formatter: (val) => (val ? val : "-"),
        },

        //  DSD-669

        // {
        //   key: "masterVoice",
        //   label: "ویس استاد",
        // },

        //  DSD-669

        // {
        //   key: "studentFeedBackQuestions",
        //   label: "سوالات (نقاط ضعف)",
        // },
        {
          key: "isPass",
          label: "وضعیت جلسه",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
      tempSchedule: null,
    };
  },
  methods: {
    renderScheduleHistoryUpdateModal(schedule) {
      this.tempSchedule = JSON.parse(JSON.stringify(schedule));
      this.$bvModal.show("edit-comment-in-history");
    },
    closeScheduleHistoryCreateModal() {
      this.$bvModal.hide("add-comment-to-history");
      this.getScheduleList();
    },
    closeScheduleHistoryUpdateModal() {
      this.$bvModal.hide("edit-comment-in-history");
      this.getScheduleList();
      this.tempSchedule = null;
    },
    setLesson(lessonId) {
      this.scheduleListFilters.lessonId = lessonId;
    },
    setCreateDateFilter(createDate) {
      if (createDate) {
        this.scheduleListFilters.createDate = new Date(
          createDate
        ).toISOString();
      } else {
        this.scheduleListFilters.createDate = null;
      }
    },
    renderCreateScheduleHistoryModal() {
      this.$bvModal.show("add-comment-to-history");
    },
    setPageNumberQuery(pageNumber) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          scheduleHistoryPageNumber: pageNumber,
        },
      });
    },
    setPageNumberAndSendRequest() {
      this.scheduleListFilters.pageNumber = 1;
      this.setPageNumberQuery(1);
      this.getScheduleList();
    },
    changePage(pageNumber) {
      this.scheduleListFilters.pageNumber = pageNumber;
      this.setPageNumberQuery(pageNumber);
      this.getScheduleList();
    },
    async getScheduleList() {
      try {
        this.isLoading = true;
        let _this = this;
        let getMasterStudentLessonList = new GetMasterStudentLessonList(_this);
        getMasterStudentLessonList.setRequestParamDataObj(
          _this.scheduleListFilters
        );
        await getMasterStudentLessonList.fetch((res) => {
          _this.totalCount = res.total;
          _this.scheduleList = res.data;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    canEditComment(userId) {
      if (getUserData()?.user?.userId == userId) {
        return true;
      }
      return false;
    },
  },
  computed: {
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
    pageNumber() {
      return this.scheduleListFilters.pageNumber;
    },
    computedPageRouteQuery() {
      if (this.$route.query && this.$route.query.scheduleHistoryPageNumber) {
        return this.$route.query.scheduleHistoryPageNumber;
      }
      return null;
    },
  },
  mixins: [timeConvertUtils],
  components: {
    BFormGroup,
    BFormSelect,
    BButton,
    CreateScheduleHistoryModal,
    UpdateScheduleHistoryModal,
    SearchInput,
    CustomDatePicker,
    IndependentLessonPicker,
    PageWrapper,
    CustomTable,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import CreateScheduleHistoryModal from "@/views/components/Utils/CreateScheduleHistoryModal.vue";
import UpdateScheduleHistoryModal from "@/views/components/Utils/UpdateScheduleHistoryModal.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import IndependentLessonPicker from "@/views/components/Lessons/IndependentLessonPicker.vue";
import timeConvertUtils from "@/mixins/timeConvertUtils";
import { GetMasterStudentLessonList } from "@/libs/Api/MasterStudentLessonView";
import { getUserData } from "@/auth/utils";
import { BFormGroup, BFormSelect, BButton } from "bootstrap-vue";
</script>
<style scoped>
@media only screen and (max-width: 768px) {
  .custom-comment-col {
    min-width: 15rem;
  }
}
@media only screen and (min-width: 769px) {
  .custom-comment-col {
    min-width: 10rem;
  }
}
</style>
<style>
.custom-comment-col > p {
  margin-bottom: 0.2rem !important;
}
</style>
